import Vue from 'vue';
import VeeValidate, {Validator} from 'vee-validate';
import App from './App.vue';
import router from './router';
import store from './store';
import IncludeSvg from './components/IncludeSvg.vue';
import Btn from '@/components/Buttons';
import Error from '@/components/Error';
import TextTruncate from '@/components/TextTruncate';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import VueGraph from 'vue-graph';
import VueCardFormat from 'vue-credit-card-validation';
import VueSignaturePad from 'vue-signature-pad';
import GeneralSettings from '@/settings';

Vue.config.productionTip = process.env.NODE_ENV === 'development';

Validator.localize(GeneralSettings.validatorDictinary);
Vue.use(VeeValidate, {
  events: 'input|blur',
});

Vue.component('include-svg', IncludeSvg);
Vue.component('btn-block', Btn);
Vue.component('error-block', Error);
Vue.component('text-truncate', TextTruncate);

Vue.use(VueCardFormat);
Vue.use(VueSignaturePad);

Vue.use(VueMoment, {
  moment
});

Vue.use(VueGraph);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
